import { render } from "./PsNavBar.vue?vue&type=template&id=3ec14502"
import script from "./PsNavBar.vue?vue&type=script&lang=js"
export * from "./PsNavBar.vue?vue&type=script&lang=js"

import "./PsNavBar.vue?vue&type=style&index=0&id=3ec14502&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__